import React, { forwardRef } from "react";
import classNames from "classnames";

import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles<Theme, { gap?: number }>(theme => ({
  hstack: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: ({ gap }) => gap
  }
}));

const HStack = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { gap?: number }
>((props, ref) => {
  const { className, gap, ...restProps } = props;

  const classes = useStyles({ gap });

  return (
    <div
      ref={ref}
      className={classNames(classes.hstack, className)}
      {...restProps}
    />
  );
});

export default HStack;
